import { Component, OnInit, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { wobble } from '../animations/wobble';
import { height } from '../animations/height';
import { AnimatedComponentOnScrollAndResize } from '../classes/animated-component-on-scroll-and-resize';
import { ScreenService } from '../shared/services/screen.service';
import { faBars, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
    animations: [wobble, height],
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent extends AnimatedComponentOnScrollAndResize implements OnInit {
    public navbarCollapsed: boolean;
    public wobbleDirection: string;
    public faBars: IconDefinition = faBars;

    constructor(elementRef: ElementRef,
                screenService: ScreenService,
                @Inject(PLATFORM_ID) platformId: Object) {
        super(elementRef,
              screenService,
              platformId);
    }

    ngOnInit(): void {
        this.wobbleDirection = 'left';
        this.navbarCollapsed = true;
    }

    onEnd(event) {
      if (event.toState === 'left') {
          this.wobbleDirection = 'right';
      } else if (event.toState === 'right') {
          this.wobbleDirection = 'left';
      }
  }
}
